import InteractiveCatalogPageItem from '../InteractiveCatalogPageItem';

export default class BrowserItem extends InteractiveCatalogPageItem {

    constructor() {
        super();
        this.url = '';
        this.preLoad = false;
    }

}
